import {Injectable} from "@angular/core";
import {AppModeEnum} from "./app/enums/appMode.enum";
import {DiscoverTypeEnum} from "./app/enums/discoverType.enum";
import {ChooseTypeEnum} from "./app/enums/chooseType.enum";

@Injectable()
export class AppConfig {

  public static fbInitParams = {
    appId: '146595352682899',
    xfbml: true,
    version: 'v2.11'
  };

  public static fbShareConfigs = {
    image: "",
    title: "Random Ride",
    description: ""
  };

  public static screenWidth = {
    smallMaxWidth: 600,
    mediumMaxWidth: 992,
    largeMinWidth: 993,
    extraLargeMinWidth: 1200,
  };

  public static locale = "en-US";

  public static onlyMoldova = true;

  public static defaultParams = {
    mode: AppModeEnum.choose,
    choose: ChooseTypeEnum.poi,
    discover: DiscoverTypeEnum.country,
    country: 'MD',
    radius: 100,
    approximation: 10,
    quantity: 15
  }

}

@Injectable()
export class AppConstants {
  public static encodedCountryBorderPolygons = {
    "MD": "gnoeHqj_bDznHumc@frHevSrtc@i__@rsb@ylMl`Km~Hb_OcjEb_Vwe[n{EySxrEylTpiObl@xog@_zl@xjYufc@hiFkjNt{z@i{ZtzMioEltSbkFdiKuhGdxs@lvUhw]l~H`d[_zG|dE|iClje@yoI`tHnlRj_JccSvtO{dHkwI_bDohCg}GbuB_yd@gfAczGg`D{m@__DbuBklBkvGc_CrkCkiFb`@{}BbrForHkiFka@ozIgnG{EgkAc|PkvBgxBcxCfc@czBgzK{oDwwAkdKzbCo_E_q@{bHsei@wnCku@kyMfqC{fPkkOs_Nb|P{_Go`BovU~kEwaLs_Sc_Hkg`@vt@_yArkHsv@vfLzJz|E~~CrcBgqCcoEcwFoUojGojGzc@gcEkoC?orCzwJ_|GohCwQcqI{aPjdAktCrpHvo@fkAo|MjdF{zAbwAk_FwiCc_HogFjz@obAgsL{pFg@bgIojLjiFwqD~cDjRvrA{bCoPobFcjEczGrI{}`@sqEk|D_l@z|J{rEv|KgpAchA_dDbzB~p@zoDojBneGkyCnzD{bCnPgvC{gM_`Kv_Ck`RcxCouI~cDg{CoU?z_G_fH~xFg^z~SczGb_HgcEbhZw`OsmB_aCk|DknFn}@wwAjqGbeEj|Dg`IrhGskCspM{_QzzAw{DshGo_JvwAkoC~~CoU~mIvqIn_EoPvpLcgDvbDk_FsDwiCz`DvGndEw~Ev|AklBbzGgqCn}@r~AfzKgjSrxIshGs{Ek{GcrF{wOsNk`HowHo`Brv@{pAvqIwaB~CgzKsjK{}BjnKsbJz_BwtEfaFrSb~JfnGfyDjf@~eHshBzgH_vJfeN{gCfeDcsCwLspC~cDomC_b@czBjlBghEzx`@wj@jxPjgGzlMbdHjgB_fHjsFczBoeBkaEzxBja@nzDffFvkGcmA~kEkaJghJgxGzuAvQr`K~kEbdMk_Ar{EctEb`@wo@zdBf`DjiFjMrqE{uAbmAczGo{AcuBjdAklBr|V}uDtoJerGdtEktH~jRbe@j}UknAb_H{hEzm@rfCblNzlHz{RwiCzeDkWzqHjnK~eMjdAnbFksFzeb@zdGfY~f@bvN_aHvmUbbDbpBoPntGvtJgxBjyCzm@wLjhIczGzgHfmEn{A~sAfuFtdJzuAylAyeM",
  };
}




// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/constants.ts